import React, { useState } from "react";
import { auth, global, guest } from "../routes";
import { NavLink } from "react-router-dom";
import { useUser } from "../../utils/hooks/useUser";

const Sidebar = ({ translate }) => {
  const [menuItems, setMenuItems] = useState([]);
  const user = useUser();

  React.useEffect(() => {
    const routes = { ...global, ...auth, ...guest };

    const menuItems = Object.values(routes)
      .filter((item) => item.onMenu)
      .filter((item) => item.canView.includes(user?.role?.name));

    setMenuItems(menuItems.sort((a, b) => a.order - b.order));
  }, [user?.role?.name]);

  return (
    <div className="sidebar px-0">
      {menuItems.map((item) => (
        <NavLink
          key={item.name}
          className="sidebar-item"
          to={item.link}
          end={item.link === "/"}
        >
          {item.icon}
          <span className="sidebar-item-text">
            {translate(`page_titles.${item.name}`).toLocaleUpperCase()}
          </span>
        </NavLink>
      ))}
    </div>
  );
};

export default Sidebar;
